import axios from "axios";

export default {
    deleteUser(id, userInteractiveId) {
        return axios({
            method: "post",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/"+id+"/user/"+userInteractiveId+"/delete",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    bannedUser(id, userInteractiveId) {
        return axios({
            method: "post",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/"+id+"/user/"+userInteractiveId+"/banned",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    desbannedUser(id, userInteractiveId) {
        return axios({
            method: "post",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/"+id+"/user/"+userInteractiveId+"/desbanned",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    create(data) {
        return axios({
            method: "post",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive",
            data: data,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    init(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/" + id + "/init",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    update(id, data) {
        return axios({
            method: "put",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/" + id,
            data: data,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    finish(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/" + id + "/finish",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    get(id) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/" + id,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    addInteractiveUser(id, data){
        return axios({
            method: "post",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/"+id+"/user",
            data: data,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getAllInteractiveUser(id){
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/"+id+"/users",
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    getNext(number) {
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "auth/interactive/nexts/" + number,
            headers: {
                authorization: localStorage.getItem("authorization"),
            },
        });
    },
    checkPaymentPublic(interactiveId, email){
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/interactive/" + interactiveId + "/" + email,
        });
    },
    getPublic(interactiveId, token, email){
        return axios({
            method: "get",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/interactive/" + interactiveId + "/" + token + "/" + email,
        });
    },
    checkPaymentPublic(interactiveId,email){
        return axios({
            method: "post",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/interactive/"+interactiveId+"/"+email+"/check",
        });
    },
    payStripe(interactiveId,email){
        return axios({
            method: "post",
            url: process.env.VUE_APP_BASE_URL_CORE + "public/interactive/"+interactiveId+"/"+email+"/pay/stripe",
        });
    }
};
